import { Theme, alpha } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

/* Options */
import widthNav from 'src/layout/Navigation/windowWidthNavConfig'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
      zIndex: theme.zIndex.appBar,
      '& .MuiAppBar-root': {
        zIndex: theme.zIndex.appBar,
        opacity: 1,
        visibility: 'visible',
      },
      '& h6': {
        display: 'inline-block',
        cursor: 'pointer',
      },
    },

    builderAppBar: {
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.appBar,
      opacity: 1,
      visibility: 'visible',
      transition: 'box-shadow 220ms ease, background-color 220ms ease',
      borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
      [theme.breakpoints.down('md')]: {
        paddingTop: 'env(safe-area-inset-top, 0px)',
      },
    },
    builderAppBarInFlow: {
      '@supports (overflow: clip)': { position: 'relative !important' },
    },
    builderSpacer: {
      '@supports (overflow: clip)': { display: 'none' },
    },
    builderOverlay: {
      '@supports (overflow: clip)': { height: 0 },
    },
    builderTopStrip: {
      overflow: 'hidden',
      maxHeight: 'var(--builder-top-strip-max-height, 54px)',
      transition: 'max-height 220ms ease, opacity 220ms ease',
      [theme.breakpoints.down('md')]: {
        maxHeight: 'var(--builder-top-strip-max-height, 112px)',
      },
    },
    builderTopStripInner: {
      minHeight: 40,
      display: 'grid',
      alignItems: 'center',
      padding: theme.spacing(0.75, 2),
      [theme.breakpoints.down('md')]: {
        minHeight: 'auto',
        padding: theme.spacing(0.7, 1.25),
      },
    },
    builderTopStripDesktop: {
      display: 'grid',
      alignItems: 'center',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gap: theme.spacing(1.5),
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    builderTopStripMobile: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        minWidth: 0,
      },
    },
    builderTopStripCompactWrap: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(.4, .8),
      width: '100%',
      minWidth: 0,
    },
    builderTopStripTexts: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(.9),
      minWidth: 0,
      flex: 1,
    },
    builderTopStripAnchor: {
      appearance: 'none',
      background: 'none',
      border: 0,
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'inherit',
      flexWrap: 'wrap',
      gap: theme.spacing(.75),
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        opacity: .82,
      },
    },
    builderTopStripLeft: {
      justifyContent: 'flex-start',
      textAlign: 'left',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        textAlign: 'center',
      },
    },
    builderTopStripCenter: {
      justifyContent: 'center',
      textAlign: 'center',
    },
    builderTopStripRight: {
      justifyContent: 'flex-end',
      textAlign: 'right',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        textAlign: 'center',
      },
    },
    builderTopStripTitle: {
      fontSize: '.9rem',
      fontWeight: 700,
      letterSpacing: '.05em',
      textTransform: 'uppercase',
      [theme.breakpoints.down('md')]: {
        fontSize: '.76rem',
      },
    },
    builderTopStripMeta: {
      fontSize: '.82rem',
      opacity: .92,
      [theme.breakpoints.down('md')]: {
        fontSize: '.74rem',
      },
    },
    builderTopStripCompact: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: '.72rem',
      fontWeight: 600,
      letterSpacing: '.02em',
      lineHeight: 1.25,
      whiteSpace: 'normal',
    },
    builderContainer: {
      width: 'min(100%, 1600px)',
      maxWidth: '1600px',
      paddingLeft: `${theme.spacing(2.5)} !important`,
      paddingRight: `${theme.spacing(2.5)} !important`,
      [theme.breakpoints.down('md')]: {
        paddingLeft: `${theme.spacing(1.5)} !important`,
        paddingRight: `${theme.spacing(1.5)} !important`,
      },
    },

    toolbar: {
      minHeight: 78,
    },

    toolbarBuilder: {
      position: 'relative',
      minHeight: 86,
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid rgba(255, 255, 255, 0.14)',
      [theme.breakpoints.down('md')]: {
        minHeight: 78,
        display: 'grid',
        gridTemplateColumns: '40px minmax(0, 1fr) 80px',
        alignItems: 'center',
        columnGap: theme.spacing(.5),
      },
    },

    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up(widthNav.home)]: {
        display: 'none !important',
      },
    },

    builderMenuButton: {
      display: 'inline-flex !important',
      marginRight: theme.spacing(1.25),
      position: 'relative',
      zIndex: 1,
      [theme.breakpoints.down('md')]: {
        gridColumn: '1',
        marginRight: 0,
        justifySelf: 'start',
        width: 40,
        height: 40,
        padding: theme.spacing(1),
      },
    },

    title: {
      [theme.breakpoints.down(widthNav.home)]: {
        display: 'none',
      },
      minWidth: 0,
      '& > a': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },

    toolbarBrand: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'min(100%, 520px)',
      maxWidth: 'calc(100% - 280px)',
      pointerEvents: 'none',
      [theme.breakpoints.down('md')]: {
        position: 'static',
        left: 'auto',
        transform: 'none',
        gridColumn: '2',
        justifySelf: 'center',
        width: '100%',
        maxWidth: 'var(--builder-logo-mobile-max-width, clamp(188px, 60vw, 260px))',
        minWidth: 0,
        pointerEvents: 'auto',
      },
    },

    toolbarBrandInline: {
      position: 'static',
      left: 'auto',
      transform: 'none',
      width: 'auto',
      maxWidth: 'var(--builder-logo-inline-max-width, 240px)',
      justifyContent: 'flex-start',
      marginRight: theme.spacing(2.2),
      pointerEvents: 'auto',
      [theme.breakpoints.down('md')]: {
        gridColumn: '2',
        justifySelf: 'center',
        width: '100%',
        maxWidth: 'var(--builder-logo-mobile-max-width, clamp(148px, 46vw, 196px))',
        marginRight: 0,
      },
    },

    brandLink: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'min(100%, var(--builder-logo-max-width, 222px))',
      maxWidth: '100%',
      minHeight: 58,
      paddingTop: 0,
      color: 'inherit',
      textDecoration: 'none',
      pointerEvents: 'auto',
      overflow: 'visible',
      '& span': {
        overflow: 'visible !important',
        maxWidth: '100% !important',
      },
      '& img': {
        display: 'block',
        width: '100%',
        maxWidth: '100%',
        height: 'auto',
        maxHeight: 'var(--builder-logo-max-height, 54px)',
        objectFit: 'contain',
        objectPosition: 'center',
        overflow: 'visible',
        filter: 'var(--builder-logo-filter, none)',
        transition: 'filter 180ms ease, max-height 180ms ease, max-width 180ms ease',
        [theme.breakpoints.down('md')]: {
          width: 'min(100%, var(--builder-logo-mobile-max-width, var(--builder-logo-max-width, 222px)))',
          maxWidth: '100%',
          maxHeight: 'var(--builder-logo-mobile-max-height, 50px)',
        },
      },
      [theme.breakpoints.down('md')]: {
        width: 'min(100%, var(--builder-logo-mobile-max-width, var(--builder-logo-max-width, 222px)))',
        minHeight: 54,
        paddingTop: 0,
        overflow: 'hidden',
        '& span': {
          width: '100% !important',
          overflow: 'hidden !important',
        },
      },
    },

    builderDesktopNav: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: theme.spacing(.5),
        paddingBottom: theme.spacing(1.15),
      },
    },

    builderDesktopNavScroller: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1.25),
      width: '100%',
      minWidth: 0,
      overflowX: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      paddingBottom: theme.spacing(.25),
    },

    builderInlineNav: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1 1 auto',
        minWidth: 0,
        overflow: 'hidden',
      },
    },

    builderInlineNavScroller: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(.75),
      width: '100%',
      minWidth: 0,
      overflow: 'hidden',
    },

    builderNavButton: {
      padding: '8px 10px',
      minWidth: 0,
      color: 'inherit !important',
      fontSize: '1.02rem',
      fontWeight: 600,
      textTransform: 'none',
      borderRadius: 0,
      position: 'relative',
      backgroundColor: 'transparent',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 10,
        right: 10,
        bottom: 2,
        height: 2,
        borderRadius: 999,
        background: 'transparent',
        transition: 'background-color 160ms ease',
      },
      '&.active::after': {
        background: 'var(--page-builder-accent, #b86f52)',
      },
    },

    builderInlineNavButton: {
      flex: '0 1 auto',
      maxWidth: 156,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '.92rem',
      padding: '8px 8px',
    },

    buttonFilter: {
      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },
      marginRight: theme.spacing(2),
    },

    buttonKonto: {
      [theme.breakpoints.down(widthNav.konto)]: {
        display: 'none',
      },
    },

    buttonFavs: {
      [theme.breakpoints.down(widthNav.favs)]: {
        display: 'none',
      },
    },

    spacer: {
      flexGrow: 1,
      minWidth: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },

    builderActions: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(.5),
      position: 'relative',
      zIndex: 1,
      '& .MuiIconButton-root': {
        color: 'inherit',
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: '3',
        justifySelf: 'end',
        gap: 0,
        marginLeft: 0,
        '& .MuiIconButton-root': {
          width: 40,
          height: 40,
          padding: theme.spacing(1),
        },
      },
    },

    cartButton: {
      // Keep the icon's inherited header color in both empty and filled states.
      // A light ring and dark outer edge separate every shop's badge color
      // from dark hero headers as well as light catalogue headers.
      '& .MuiBadge-badge': {
        boxShadow: '0 0 0 2px #ffffff, 0 0 0 3px rgba(15, 23, 42, 0.22)',
        fontWeight: 700,
      },
    },

    builderDesktopOnlyAction: {
      [theme.breakpoints.down('md')]: {
        display: 'none !important',
      },
    },

    builderFilterButton: {
      display: 'none !important',
    },

    builderMobileNav: {
      display: 'none',
    },

    builderMobileNavScroller: {
      display: 'flex',
      gap: theme.spacing(1),
      overflowX: 'auto',
      paddingBottom: theme.spacing(.25),
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },

    builderMobileNavButton: {
      flex: '0 0 auto',
      minWidth: 'max-content',
      borderRadius: 999,
      padding: '10px 16px',
      color: 'inherit !important',
      textTransform: 'none',
      backgroundColor: alpha('#ffffff', 0.78),
      backdropFilter: 'blur(14px)',
      boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)',
      '&.active': {
        backgroundColor: 'var(--page-builder-accent, #b86f52)',
        color: 'var(--page-builder-accent-contrast, #ffffff) !important',
      },
    },
  })
)

export default useStyles
